/* eslint-disable import/prefer-default-export */
import t from './DamFile.type';
import damt from '../../../../DAM/store/DAM.type';
import * as productDam from '../../../../../services/dam-product-file.services';
import { toasterMsg } from '../../../../../Components/Toaster/Toaster';

const errMsg = 'Failed to fetch data';

export const fetchProductDamFileList = (params) => {
  return async (dispatch) => {
    try {
      const response = await productDam.fetchProductDamFileList(params);
      if (response.code === 200) {
        dispatch({
          type: t.FETCH_PRODUCT_DAM_FILE_LIST,
          payload: {
            ...params,
            data: response?.data.doc,
            totalCount: response?.data?.totalCount,
          },
        });
      }
      return response;
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const deleteProductDamFileByIdAction = (params, transactionMsg) => async () => {
  try {
    const res = await productDam.deleteProductDamFiles(params);
    if (res && res.code === 200) {
      const msg = transactionMsg(`PRODUCT_DAM.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(res.data.errMsg, 'danger');
    } else {
      toasterMsg(res.message, 'danger');
    }
  } catch (err) {
    toasterMsg(errMsg, 'danger');
  }
};

export const filterDamFileSortData = (obj) => async (dispatch) => {
  try {
    await dispatch({
      type: t.DAM_PRODUCT_FILE_SET_FILTER_SORT_DATA,
      payload: obj,
    });
  } catch (error) {
    toasterMsg(errMsg, 'danger');
  }
};

export const updateProductFileInLibraryCollection = (obj, transactionMsg) => async () => {
  try {
    const res = await productDam.updateProductFileInLibraryCollection(obj);
    if (res && res.code === 200 && res.data) {
      const msg = transactionMsg(`PRODUCT_DAM.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(`PRODUCT_DAM.BACKEND_SERVICE.${res.data.errMsg}`), 'danger');
    } else {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(errMsg, 'danger');
  }
};

export const saveProductDamFiles = (requestPayload, devOrderId, transactionMsg) => {
  return async () => {
    try {
      const res = await productDam.saveProductDamFiles(requestPayload, devOrderId);
      if (res.code === 200) {
        const msg = transactionMsg(`PRODUCT_DAM.BACKEND_SERVICE.${res.message}`);
        toasterMsg(msg, 'success');
      }
      if (res.code === 500) {
        const msg = transactionMsg(`PRODUCT_DAM.BACKEND_SERVICE.${res.data.errMsg}`);
        toasterMsg(msg, 'danger');
      }
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const getDamProductRecordById = (damId, devOrderId) => {
  return async (dispatch) => {
    try {
      const response = await productDam.getDamProductRecordById(damId, devOrderId);
      if (response?.code === 200) {
        dispatch({
          type: damt.DAM_EDIT_DATA,
          payload: response?.data,
        });
      }
      return response;
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const updateProductDamFiles = (requestPayload, devOrderId, transactionMsg) => {
  return async () => {
    try {
      const res = await productDam.updateProductDamFiles(requestPayload, devOrderId);
      if (res.code === 200) {
        const msg = transactionMsg(`PRODUCT_DAM.BACKEND_SERVICE.${res.message}`);
        toasterMsg(msg, 'success');
      }
      if (res.code === 500) {
        const msg = transactionMsg(`PRODUCT_DAM.BACKEND_SERVICE.${res?.data?.errMsg}`);
        toasterMsg(msg, 'danger');
      }
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const fetchProductDamTag = () => {
  return async (dispatch) => {
    try {
      const response = await productDam.fetchProductDamTag();
      dispatch({
        type: damt.DAM_TAGS_LIST,
        payload: response?.data,
      });
      return response?.data;
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const fetchProductFolderOptionList = (params) => {
  return async (dispatch) => {
    try {
      const response = await productDam.fetchProductFolderOptionList(params);
      if (response.code === 200) {
        dispatch({
          type: t.SET_PRODUCT_FOLDERS_OPTION,
          payload: {
            ...params,
            data: response?.data,
          },
        });
      }
      return response;
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const checkProductDamNameExist = (requestPayload, devOrderId) => {
  return async () => {
    try {
      const res = await productDam.checkProductDamNameExist(requestPayload, devOrderId);
      return res.data;
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};
